import { useEffect, useState } from "react";

import { authFetch } from "@/api/client";
import { KpiCard } from "@/components/KpiCard";

interface DashboardKpi {
  markets_open: number;
  markets_pending_resolution: number;
  withdrawals_in_queue: number;
  audit_log_today: number;
}

const EMPTY: DashboardKpi = {
  markets_open: 0,
  markets_pending_resolution: 0,
  withdrawals_in_queue: 0,
  audit_log_today: 0,
};

export function DashboardPage() {
  const [kpi, setKpi] = useState<DashboardKpi | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const res = await authFetch("/v1/admin/dashboard");
        if (!res.ok) throw new Error(`dashboard ${res.status}`);
        const data = (await res.json()) as DashboardKpi;
        if (!cancelled) setKpi(data);
      } catch (e) {
        if (cancelled) return;
        // L'endpoint admin potrebbe non essere ancora pronto: mostra placeholder
        // e segnala l'errore in modo sobrio.
        setErr(e instanceof Error ? e.message : "errore sconosciuto");
        setKpi(EMPTY);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex flex-col gap-6 max-w-[1200px]">
      <header>
        <h1 className="text-[22px] font-semibold">Dashboard</h1>
        <p className="text-[13px] text-muted mt-1">
          Panoramica operativa real-time del marketplace Quantica.
        </p>
      </header>

      <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <KpiCard
          label="Markets aperti"
          value={kpi ? kpi.markets_open : "—"}
          hint="Trading attivo, ordini accettati"
        />
        <KpiCard
          label="Risoluzioni pending"
          value={kpi ? kpi.markets_pending_resolution : "—"}
          accent
          hint="In attesa di outcome confermato"
        />
        <KpiCard
          label="Prelievi in coda"
          value={kpi ? kpi.withdrawals_in_queue : "—"}
          accent
          hint="Da revisionare/processare"
        />
        <KpiCard
          label="Eventi audit oggi"
          value={kpi ? kpi.audit_log_today : "—"}
          hint="Operazioni amministrative registrate"
        />
      </section>

      {err && (
        <div className="text-[12px] text-muted">
          Endpoint <span className="font-mono">/v1/admin/dashboard</span> non
          raggiungibile ({err}). I valori mostrati sono placeholder.
        </div>
      )}

      <section className="card">
        <h2 className="text-[15px] font-semibold mb-1">Attività recente</h2>
        <p className="text-[12.5px] text-muted">
          Lo stream di eventi audit live verrà collegato qui non appena
          l&apos;endpoint <span className="font-mono">/v1/admin/audit</span>{" "}
          sarà disponibile. Per ora consulta la pagina dedicata.
        </p>
      </section>
    </div>
  );
}
